var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-child-page-ctas" }, [
    _c("div", { staticClass: "c-child-page-ctas__inner" }, [
      !_vm.items.length
        ? _c("div", { staticClass: "c-child-page-ctas__content" }, [
            _c("p", { staticClass: "c-child-page-ctas__text" }, [
              _vm._v(
                "\n         " + _vm._s(_vm.options.noResultsText) + "\n       "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.items.length
        ? _c(
            "div",
            { staticClass: "c-child-page-ctas__content" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "c-child-page-ctas__cell" },
                [
                  _c("Spotlight", {
                    attrs: {
                      date: item.date,
                      image: item.imageUrl,
                      link: item.pageUrl,
                      showSummary: index < 2,
                      summary: item.summary,
                      theme: _vm.theme,
                      title: item.title
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.items.length,
              expression: "items.length"
            }
          ],
          staticClass: "c-child-page-ctas__actions"
        },
        [
          _vm.options.loadMoreText && _vm.currentPage < _vm.totalPages
            ? _c(
                "button",
                {
                  staticClass: "c-child-page-ctas__button",
                  on: { click: _vm.loadItems }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.options.loadMoreText) + "\n      "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b377ebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b377ebc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/developers/child-page-ctas/ChildPageCtas.vue
// module id = 547
// module chunks = 0